module.exports = __webpack_public_path__ + "static/img/暖通行业解决方案.8fc06b2e.png";